import actions from './actions';
import getters from './getters';
import mutations from './mutations';
export var state = () => ({
  currentImage: null,
  product: null,
  productInspiration: null,
  productCross: null,
  productComplementary: null,
  productXsellAddToCart: null,
  variants: [],
  productRR: null
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};